import React from "react";
import { Edit } from "@mui/icons-material";

import { useFeatureFlag } from "fond/featureFlags";
import { useLayerPanelContext } from "fond/project/panels/InputPanel/LayerPanelContext";
import { StackedNavigationButton, useStackedNavigationContext } from "fond/widgets";

/**
 * `LayerPanel` action for editing path preferences.
 */
const LayerPathPreferencesAction: React.FC = () => {
  const { layerKey } = useLayerPanelContext();
  const { open } = useStackedNavigationContext();
  const { value: pathPreferencingEnabled } = useFeatureFlag("path_preferencing", false);

  if (!pathPreferencingEnabled) return null;

  return (
    <StackedNavigationButton
      data-testid={`path-preferences-${layerKey}-button`}
      icon={<Edit />}
      title="Path preferences"
      subtitle="Edit path preferences"
      onClick={() => open(`${layerKey}-path-preferences`)}
    />
  );
};

export default LayerPathPreferencesAction;
